import { useMemo, useState } from "react";

type PokeImg = {
  img: string;
  gif: string;
};

const usePokeInfo = (
  id: number
): readonly [string | undefined, PokeImg | undefined, boolean] => {
  const [loading, setLoading] = useState<boolean>(false);
  const [pokeColor, setPokeColor] = useState<string>();
  const [pokeImg, setPokeImg] = useState<PokeImg>();

  const getPokemonColor = async (idColor: number) => {
    const res = await fetch(
      `https://pokeapi.co/api/v2/pokemon-species/${idColor}/`
    );
    const resultado = await res.json();
    setPokeColor(resultado.color.name);
  };

  const getPokemonImg = async (idImg: number) => {
    const res = await fetch(`https://pokeapi.co/api/v2/pokemon/${idImg}`);
    const resultado = await res.json();
    await getPokemonColor(resultado.id);
    setPokeImg({
      img: resultado.sprites.front_default,
      gif: resultado.sprites.versions["generation-v"]["black-white"].animated
        .front_default
    });
  };

  useMemo(async () => {
    setLoading(true);
    await getPokemonColor(id);
    await getPokemonImg(id);
    setLoading(false);
  }, [id]);

  return [pokeColor, pokeImg, loading] as const;
};

export default usePokeInfo;
